import styled from 'styled-components';
import {
  getSpace,
  getColor,
  setGridColumns,
  gridContainer,
  getGridSpans,
  getGridSpan,
  mq
} from '../../../stylesheets/tools';

const StyledGameTeaser = styled.div`
  postion: relative;
  margin: ${getSpace('xxl')} 0;

  .gameTeaser__grid {
    ${gridContainer()}
    ${setGridColumns('1fr', 12)}
    grid-gap: 10px;
    grid-row-gap: 0;
  }

  .gameTeaser__image,
  .gameTeaser__content {
    position: relative;
    ${getGridSpans('width', { s: 11, m: 10 })};
    margin: 0 ${getGridSpan('1', 'spread')};

    ${mq('m')} {
      margin: 0 ${getGridSpan('1', 'spread')};
    }

    img {
      width: 100%;
    }
  }

  .gameTeaser__image:before {
    content: '';
    position: absolute;
    width: 95%;
    height: 100%;
    left: 28px;
    top: 44px;
    background-color: ${props => props.theme.siteTheme.primary};
    transform: rotate(-3.8deg);
    z-index: -1;

    ${mq('m')} {
      left: 80px;
    }
  }

  .gameTeaser__content {
    display: flex;
    flex-direction: column;
    margin-top: ${getSpace('xxl')};

    ${mq('m')} {
      flex-direction: row;
      gap: ${getSpace('s')};
      margin-top: ${getSpace('xxxl')};
    }
  }

  .gameTeaser__headline {
    ${mq('m')} {
      width: 30%;
    }
  }

  .gameTeaser__copy {
    ${mq('m')} {
      width: 70%;
    }
  }

  .gameTeaser__cta {
    gap: ${getSpace('xs')};
    margin-top: ${getSpace('s')};

    & > svg {
      width: 28px;
      height: 28px;
    }
  }
`;

const StyledLightbox = styled.div`
  positon: relative;

  .gameTeaser__close {
    position: absolute;
    top: ${getSpace('s')};
    right: ${getSpace('s')};
    color: ${getColor('white')};
  }

  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;

export { StyledGameTeaser, StyledLightbox };
